import { SUPPLIER_BACKEND_API_ENDPOINTS } from "../config/apiConfig";
import { apiClient } from "./api-client.service";

import type { DashboardResponse } from "../types/reports.types";

const endpoints = SUPPLIER_BACKEND_API_ENDPOINTS.reports;

export const reportsService = {
  async dashboard(): Promise<DashboardResponse> {
    try {
      return await apiClient<DashboardResponse>(endpoints.dashboard, {
        method: "GET",
        isAuthenticated: true,
        cache: "no-store",
      });
    } catch (error) {
      return {
        success: false,
        statusCode: 500,
        message: error instanceof Error ? error.message : "Failed to load dashboard due to an unexpected error.",
        resData: null,
      };
    }
  },
};
